import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  he: {
    translation: {
      // SEO - titles and descriptions per page
      seo: {
        homeTitle: "סדנאות לחם מחמצת | שמואל סולה - SullaBread",
        homeDescription:
          "סדנאות אפייה לחמי מחמצת עם שמואל (סרגיי) סולה. למדו להכין לחם אמיתי בבית. מעל 20 שנות ניסיון באפיית לחמי מחמצת.",
        workshopsTitle: "סדנאות אפייה | לחם מחמצת עם שמואל סולה",
        workshopsDescription:
          "הצטרפו לסדנאות אפייה אישיות. לימדו צעד-אחר-צעד לאפות לחם מחמצת טרי ובריא בבית, בלי שמרים ובלי פחד.",
        workshopDetailTitle: "פרטי סדנה | שמואל סולה - SullaBread",
        workshopDetailDescription:
          "פרטים והרשמה לסדנת אפיית לחם מחמצת עם שמואל סולה. סדנאות אישיות, חומרים מהשורה הראשונה.",
        aboutTitle: "שמואל (סרגיי) סולה | אופה לחמי מחמצת מעל 20 שנה",
        aboutDescription:
          "הכירו את שמואל סולה, אופה לחמי מחמצת מעל 20 שנה. מהנדס שהפך לאופה, מלמד אפייה ביתית בסדנאות אישיות.",
        blogTitle: "בלוג לחם מחמצת | מתכונים וטיפים - SullaBread",
        blogDescription:
          "מתכונים, טיפים ומאמרים על אפיית לחם מחמצת ביתי מאת שמואל סולה. כל מה שצריך לדעת על מחמצת.",
        blogDetailTitle: "מאמר | בלוג לחם מחמצת - SullaBread",
        blogDetailDescription:
          "מאמר מבלוג לחם המחמצת של שמואל סולה. טיפים, מתכונים וידע על אפייה ביתית.",
        galleryTitle: "גלריה | תמונות מסדנאות הלחם של שמואל סולה",
        galleryDescription:
          "תמונות מסדנאות אפייה, לחמים טריים מהתנור ורגעים מהסדנאות של שמואל סולה.",
        contactTitle: "צור קשר | שמואל סולה - SullaBread",
        contactDescription:
          "רוצים להירשם לסדנת לחם מחמצת או לשאול שאלה? צרו קשר עם שמואל סולה.",
        privacyTitle: "מדיניות פרטיות | SullaBread",
        privacyDescription:
          "מדיניות הפרטיות של אתר SullaBread - סדנאות לחם מחמצת עם שמואל סולה.",
        accessibilityTitle: "הצהרת נגישות | SullaBread",
        accessibilityDescription:
          "הצהרת הנגישות של אתר SullaBread - סדנאות לחם מחמצת עם שמואל סולה.",
        cancellationTitle: "מדיניות ביטולים | SullaBread",
        cancellationDescription:
          "מדיניות הביטולים וההחזרים של סדנאות לחם מחמצת SullaBread.",
        giftVoucherTitle: "שובר מתנה | סדנאות לחם מחמצת - SullaBread",
        giftVoucherDescription:
          "רכשו שובר מתנה לסדנת אפיית לחם מחמצת עם שמואל סולה. מתנה מושלמת לאוהבי אפייה.",
      },

      // Navigation
      home: "דף הבית",
      workshops: "סדנאות",
      about: "אודות",
      giftVoucher: "שובר מתנה",
      contact: "יצירת קשר",
      blog: "בלוג מתכונים/מאמרים",
      gallery: "גלריה",
      openMenu: "פתח תפריט",
      closeMenu: "סגור תפריט",
      mainNavigation: "ניווט ראשי",
      galleryDescriptionBolt: "רגעים מהתנור ומהלב.",
      allGallery: "מעבר לגלריה",
      previous: "הקודם",
      next: "הבא",
      page: "עמוד",
      of: "מתוך",
      images: "תמונות",

      galleryDescription:
        "הצצה לתוך עולמה של האפייה הביתית – לחמים טריים, סדנאות מלאות השראה, וחיוכים של בוגרי הקורסים.\n ככה זה נראה כשאופים מכל הלב.",
      location: "מיקום יקבע",

      // Home page
      heroTitleLine1: "לחם אמיתי,",
      heroTitleLine2: "מחמצת פשוטה,",
      heroTitleLine3: "תוצאה מושלמת.",
      heroSubtitle:
        "שלום, אני שמואל (סרגיי) סולה. למדו איתי לאפות לחם מחמצת אמיתי בבית",
      heroDescription:
        '"שמואל (סרגיי) סולה, אופה לחמים כבר 20 שנה.\nבואו ללמוד איך להכין בבית לחם אמיתי על בסיס מחמצת\nבלבד, בלי סודות, בלי שמרים, ובלי פחד."',
      heroImageAlt: "תמונת כותרת - לחם ביתי איכותי מסדנאות אפייה",
      featuredWorkshops: "סדנאות מומלצות",
      viewWorkshops: "צפה בסדנאות",
      joinWorkshops: "הצטרפו עכשיו לסדנאות",
      workshopsDescriptionBolt:
        "בואו לגלות כמה פשוט להכין לחם \n מחמצת אמיתי בבית.",
      workshopsDescription:
        "בסדנאות האישיות שלי תלמדו צעד-אחר-צעד איך לאפות לחם טרי,\n בריא וטעים –בלי שמרים, בלי קמחים יוקרתיים ובלי לחץ.\nהשיטה שלי מתאימה לכולם, גם אם זו הפעם הראשונה שלכם במטבח.",
      purchaseNow: "הרשמה לסדנה",
      loadingWorkshops: "טוען סדנאות מומלצות...",
      noWorkshopsAvailable: "אין סדנאות זמינות כרגע",

      // Workshop page
      workshopsTitle: "סדנאות אפייה",
      upcomingWorkshops: "סדנאות קרובות",
      workshopDetails: "פרטי הסדנה",
      price: "מחיר",
      duration: "משך הסדנה",
      register: "הרשמה לסדנה",
      available: "פנוי להרשמה",
      unavailable: "לא זמין",
      chooseDate: "בחירת תאריך לסדנה",
      selectDate: "בחר תאריך",
      viewDetails: "צפה בפרטים",
      viewImage: "צפה בתמונה",
      availableSeats: "מקומות פנויים",
      full: "מלא",
      workshopFull: "הסדנה מלאה",
      noDatesAvailable: "אין תאריכים זמינים לסדנה זו",
      registrationForm: "טופס הרשמה ותשלום לסדנה",
      numberOfPeople: "כמות אנשים להרשמה",
      decreaseTickets: "הפחתת כמות כרטיסים",
      increaseTickets: "הוספת כמות כרטיסים",
      totalToPay: "סה״כ לתשלום",
      recaptcha: "אימות אבטחה",
      paymentTransition: "מעבר לתשלום",
      paymentButton: "שלם",
      cancel: "ביטול",
      pleaseFillOutTheFollowingDetails: "אנא מלאו את הפרטים הבאים",
      paymentForWorkshopRegistration: "תשלום עבור הרשמה לסדנה",
      pleaseCompletePaymentDetails: "אנא השלם את פרטי התשלום",
      securePaymentTranzila:
        "🔒 התשלום מתבצע באמצעות מערכת מאובטחת של Tranzila. פרטי הכרטיס שלך מוגנים ומוצפנים.",
      processingPayment: "מעבד תשלום...",
      pleaseWaitRedirecting: "אנא המתן, מעביר אותך לתשלום",
      date: "תאריך",
      time: "שעה",

      // Gift voucher (שובר מתנה)
      giftVoucherPageTitle: "שובר מתנה",
      giftVoucherPageSubtitle: "מתנה מתוקה לאנשים שאתם אוהבים",
      giftVoucherPageIntro:
        "בחרו את מספר המשתתפים, רכשו את השובר, וקוד אישי יישלח אליכם למייל. מקבל המתנה יוכל לממש את הקוד בהרשמה לכל סדנה באתר.",
      giftVoucherPeopleLabel: "מספר משתתפים בשובר",
      giftVoucherPricePerPerson: "מחיר לאדם",
      giftVoucherTotal: "סה״כ לתשלום",
      giftVoucherPurchaseButton: "רכישת שובר מתנה",
      giftVoucherNotAvailable:
        "רכישת שוברי מתנה אינה זמינה כרגע. אנא נסו שוב מאוחר יותר.",
      giftVoucherSuccessTitle: "השובר נרכש בהצלחה!",
      giftVoucherSuccessMessage:
        "תודה על הרכישה! שלחנו את קוד השובר גם לכתובת המייל שלכם.",
      giftVoucherYourCode: "קוד השובר שלכם",
      giftVoucherCodeNote: "שמרו את הקוד - יש להזין אותו בעת ההרשמה לסדנה.",
      giftVoucherActivationError:
        "לא הצלחנו להפעיל את השובר. נסו לרענן את הדף או צרו קשר.",
      giftVoucherCreating: "יוצר שובר...",

      // Gift voucher redemption in registration
      voucherCodeLabel: "יש לך שובר מתנה?",
      voucherCodePlaceholder: "הזן קוד שובר מתנה",
      voucherApply: "החל",
      voucherRemove: "הסר שובר",
      voucherApplied: "השובר הוחל! מכסה {{count}} משתתפים",
      voucherDiscount: "הנחת שובר מתנה",
      voucherChecking: "בודק...",
      voucherNotFound: "קוד השובר לא נמצא",
      voucherNotActive: "השובר אינו פעיל עדיין",
      voucherAlreadyRedeemed: "השובר כבר מומש",
      voucherInvalid: "קוד שובר לא תקין",

      // Contact page
      contactUs: "צרו איתנו קשר",
      name: "שם",
      email: 'דוא"ל',
      message: "הודעה",
      send: "שלח",
      contactTitle: "צרו קשר",
      contactQuestions: "יש לכם שאלות?",
      contactIntro: "מוזמנים ליצור קשר בדרך שנוחה לכם \n ואחזור אליכם בהקדם.",
      namePlaceholder: "שם מלא",
      emailPlaceholder: "איימיל (חובה)",
      phonePlaceholder: "טלפון",
      messagePlaceholder: "השאירו הודעה כאן...",
      sending: "שולח...",
      sendButton: "שליחת טופס",
      loading: "טוען...",
      processing: "מעבד את המידע...",
      errorMessage: "שגיאה בשליחת ההודעה. אנא נסה שוב.",
      consentCheckbox: "אני מסכים לאיסוף ועיבוד המידע המוצג בטופס זה בהתאם ל",
      privacyPolicy: "מדיניות הפרטיות",
      consentCheckboxDescription: "של האתר",
      thankYouTitle: "תודה שיצרתם קשר",
      thankYouMessage: "ההודעה שלכם התקבלה בהצלחה, אצור איתכם קשר בהקדם.",

      // Email: contact auto-reply (צור קשר)
      emails: {
        contactAutoReply: {
          subject: "תודה שפנית אלינו - {{siteName}}",
          title: "הודעתך התקבלה בהצלחה!",
          greeting: "שלום",
          body: "תודה שפנית אלינו. קיבלנו את פנייתך ונחזור אליך בהקדם האפשרי.",
          yourMessage: "תוכן ההודעה ששלחת:",
          regards: "בברכה,",
          teamLabel: "צוות",
          footer: "זהו מענה אוטומטי המאשר את קבלת הפנייה.",
          defaultName: "לקוח יקר",
        },
        giftVoucher: {
          subject: "שובר המתנה שלך - {{siteName}}",
          title: "שובר המתנה שלך מוכן!",
          greeting: "שלום",
          body: "תודה על רכישת שובר המתנה. להלן קוד השובר למימוש בהרשמה לסדנה:",
          codeLabel: "קוד השובר",
          participantsLabel: "השובר מזכה ב-{{count}} משתתפים",
          howToUse: "להזין את הקוד בעת ההרשמה לסדנה כדי לקבל את ההנחה.",
          regards: "בברכה,",
          teamLabel: "צוות",
          footer: "שמרו על הקוד במקום בטוח. השובר ניתן למימוש חד-פעמי.",
          defaultName: "לקוח יקר",
        },
      },

      // Privacy Policy page
      privacyPolicyTitle: "מדיניות פרטיות",
      privacyWelcome: "ברוכים הבאים לאתר Sullabread",
      privacyWelcomeText:
        "אנו מחויבים לשמור על פרטיות המשתמשים בהתאם לחוק הגנת הפרטיות הישראלי ולתקנות העדכניות.",
      privacyCollectionTitle: "איסוף מידע ואישור",
      privacyCollectionText:
        "בעת מילוי טפסים באתר, ייתכן שתתבקש לסמן תיבת סימון (checkbox) לאישור איסוף ועיבוד המידע המוצג בטופס. הסימון הוא אקטיבי ומפורש.",
      privacyRightsTitle: "זכויות צפייה ומחיקה",
      privacyRightsText:
        "כדי לעיין, לעדכן או לבקש מחיקה של מידע שהעברת אלינו, יש לפנות לטופס יצירת הקשר שבאתר. אנו נטפל בבקשות אלה בהתאם לחוק.",
      privacyUsageTitle: "שימוש במידע",
      privacyUsageText:
        "המידע שנאסף נעשה לשם טיפול בפניות, שיפור השירותים ומתן עדכונים, בכפוף להסכמתך.",
      privacySecurityTitle: "אבטחת מידע",
      privacySecurityText:
        "אנו נוקטים באמצעים להגנה על המידע מפני גישה בלתי מורשית או שינוי.",
      privacyCookiesTitle: "שימוש בעוגיות (Cookies)",
      privacyCookiesTextUp:
        "האתר משתמש בעוגיות לשיפור חוויית המשתמש ולשמירת העדפות. העוגיות כוללות:",
      privacyCookiesItem1: "שמירת העדפות שפה",
      privacyCookiesItem2: "שמירת העדפות נגישות",
      privacyCookiesItem3: "שמירת זמן הביקור האחרון",
      privacyCookiesItem4: "שיפור ביצועי האתר",
      privacyCookiesTextDown:
        "ניתן להשבית עוגיות בהגדרות הדפדפן, אך הדבר עלול להשפיע על תפקוד האתר.",
      privacyInquiriesTitle: "פניות ובקשות",
      privacyInquiriesText:
        "לכל שאלה או בקשה בנוגע לפרטיות המידע שלך, אנא פנה באמצעות טופס יצירת הקשר באתר.",
      backToPreviousPage: "חזרה לדף הקודם",

      // Accessibility Statement page
      accessibilityStatementTitle: "הצהרת נגישות",
      accessibilityStatementIntro: "הצהרת נגישות לאתר Sullabread",
      accessibilityStatementIntroText:
        "אתר Sullabread מחויב לספק שירות נגיש ושוויוני לכל המשתמשים, ולאפשר שימוש נוח ויעיל באתר לכלל האוכלוסייה, כולל אנשים עם מוגבלויות.",
      accessibilityStandardTitle: "תקן נגישות",
      accessibilityStandardText:
        'האתר עומד בדרישות תקן ישראלי ת"י 5568 חלק 1 (ספטמבר 2023), המבוסס על הנחיות WCAG 2.1 ברמה AA של ארגון W3C.',
      accessibilityFeaturesTitle: "התאמות נגישות שבוצעו באתר",
      accessibilityFeaturesList1: "תמיכה מלאה בניווט באמצעות מקלדת",
      accessibilityFeaturesList2: "תמיכה בקוראי מסך (Screen Readers)",
      accessibilityFeaturesList3: "תגיות תיאור לתמונות (Alt tags)",
      accessibilityFeaturesList4:
        "ניגודיות צבעים מותאמת (יחס ניגודיות מינימלי 4.5:1)",
      accessibilityFeaturesList5: "תמיכה בעברית (RTL) ורוסית (LTR)",
      accessibilityFeaturesList6: "אפשרות לדילוג לתוכן הראשי (Skip links)",
      accessibilityFeaturesList7: "סגנונות focus ברורים לניווט במקלדת",
      accessibilityFeaturesList8: "תמיכה ב-high contrast mode",
      accessibilityFeaturesList9: "תמיכה ב-reduced motion",
      accessibilityFeaturesList10: "מבנה HTML סמנטי נכון",
      accessibilityFeaturesList11: "תוויות ARIA לאלמנטים אינטראקטיביים",
      accessibilityFeaturesList12: "הודעות שגיאה נגישות",
      accessibilityContactTitle: " נגישות",
      accessibilityContactText:
        "אם נתקלתם בבעיית נגישות באתר, או שיש לכם הצעות לשיפור הנגישות, אנא פנו אלינו:",
      accessibilityContactName: "שם : שמואל סולה",
      accessibilityContactEmail: 'דוא"ל: sullabread@gmail.com',
      accessibilityContactPhone: "טלפון: 054-435-3313 ",
      accessibilityContactNote: 'אנא ציינו בנושא ההודעה: "פנייה בנושא נגישות"',
      accessibilityImprovementsTitle: "שיפורים מתוכננים",
      accessibilityImprovementsText:
        "אנו ממשיכים לשפר את נגישות האתר באופן שוטף. אם יש לכם הצעות לשיפור, נשמח לשמוע מכם.",
      accessibilityLastUpdate: "עדכון אחרון: ינואר 2025",

      // Cancellation Policy page
      cancellationPolicyTitle: "מדיניות ביטולים והחזרים",
      cancellationPolicyIntro: "מדיניות ביטולים והחזרים",
      cancellationPolicyIntroText:
        "היות ואני שומר את המקום עבורכם ומשקיע זמן והכנה רבה בבצקים ובחומרי הגלם עוד מראש, אבקש את הבנתכם לעניין מדיניות הביטולים וההחזרים שלהלן:",
      cancellationPolicyRegistrationTitle: "הרשמה לסדנא",
      cancellationPolicyRegistrationText:
        "ההרשמה לסדנא מתבצעת מראש ומהווה התחייבות לשמירת מקום.",
      cancellationPolicy72HoursTitle:
        "ביטול עד 3 ימים (72 שעות) לפני מועד הסדנא",
      cancellationPolicy72HoursText:
        "יינתן החזר כספי מלא, בניכוי דמי סליקה בשיעור 5%. לחלופין, ניתן לדחות את ההשתתפות למועד אחר, על בסיס מקום פנוי.",
      cancellationPolicy24to72HoursTitle:
        "ביטול בין 24 ל־72 שעות לפני מועד הסדנא",
      cancellationPolicy24to72HoursText:
        "יינתן החזר בגובה 50% ממחיר הסדנא. במקרה זה ניתן גם להעביר את הזכות להשתתפות למשתתף אחר, בתיאום מראש.",
      cancellationPolicyLessThan24HoursTitle:
        "ביטול פחות מ־24 שעות לפני מועד הסדנא, או אי־הגעה מכל סיבה שהיא",
      cancellationPolicyLessThan24HoursText:
        "לא יינתן החזר כספי. עם זאת, ניתן להעביר את הזכות להשתתפות למשתתף אחר, בכפוף להודעה מראש.",

      // Accessibility Toolbar
      accessibilityTools: "כלי נגישות",
      increaseText: "הגדל טקסט",
      decreaseText: "הקטן טקסט",
      grayscale: "גווני אפור",
      highContrast: "ניגודיות גבוהה",
      invertedContrast: "ניגודיות הפוכה",
      lightBackground: "רקע בהיר",
      highlightLinks: "הדגשת קישורים",
      readableFont: "פונט קריא",
      reset: "איפוס",
      close: "סגור",

      // Cookie Consent
      cookieBannerTitle: "אנו משתמשים בקוקיז",
      cookieBannerDescription:
        "אנו משתמשים בקוקיז כדי לשפר את החוויה שלך באתר, לזכור את ההעדפות שלך ולספק תוכן מותאם אישית. בחר את סוגי הקוקיז שאתה רוצה לאפשר.",
      acceptAll: "אני מסכים להכל",
      rejectAll: "דחה הכל",
      customize: "התאמה אישית",
      cookiePolicy: "מדיניות קוקיז",
      cookieCustomizeTitle: "התאמת העדפות קוקיז",
      cookieCustomizeDescription:
        "בחר את סוגי הקוקיז שאתה רוצה לאפשר. קוקיז חיוניים נדרשים לתפקוד האתר ואי אפשר לבטל אותם.",
      cookieEssentialTitle: "קוקיז חיוניים",
      cookieEssentialDescription:
        "קוקיז אלה נדרשים לתפקוד הבסיסי של האתר ואי אפשר לבטל אותם. הם כוללים טוקן אימות, מזהי הפעלה וטוקני אבטחה.",
      cookieFunctionalTitle: "קוקיז פונקציונליים",
      cookieFunctionalDescription:
        "קוקיז אלה משפרים את הפונקציונליות של האתר ושומרים את ההעדפות שלך כמו שפה, ערכת נושא ונגישות.",
      cookieAnalyticsTitle: "קוקיז אנליטיים",
      cookieAnalyticsDescription:
        "קוקיז אלה עוזרים לנו להבין איך אתה משתמש באתר ולשפר את הביצועים והתוכן שלנו.",
      cookieMarketingTitle: "קוקיז שיווקיים",
      cookieMarketingDescription:
        "קוקיז אלה משמשים לפרסום ממוקד ולמעקב אחר יעילות הקמפיינים השיווקיים שלנו.",
      alwaysActive: "תמיד פעיל",
      enabled: "מופעל",
      disabled: "מבוטל",
      saving: "שומר...",
      savePreferences: "שמור העדפות",
      // About page
      aboutTitle: "הסיפור שלנו",
      aboutSubtitle: "מאפייה קטנה עם אהבה גדולה ללחם",
      ourValues: "הערכים שלנו",
      ourStory: "הסיפור שלנו",
      storyText1:
        "הכל התחיל מאהבה ללחם טרי ומחמצת טבעית. אחרי שנים של ניסוי וטעייה, החלטנו לשתף את הידע והניסיון שלנו עם אחרים.",
      storyText2:
        "היום אנחנו מארחים סדנאות ומלמדים אנשים מכל רחבי הארץ את אמנות האפייה המסורתית.",
      aboutMainTitle: "אודות",
      aboutDescriptionBold:
        "אני שמואל (סרגיי) סולה,\n מהנדס ואופה לחמי מחמצת כבר מעל 20 שנה.",
      aboutDescriptionRegular:
        "בסדנאות שלי אני מלמד איך להכין בבית לחם אמיתי,\n טרי וריחני – בלי שמרים, בלי קמחים יוקרתיים\n ובלי סודות מקצועיים.\n שיטה פשוטה, ליווי אישי וקהילה חמה של אוהבי לחם.",
      aboutButton: "למדו עוד עליי",
      aboutImageAlt: "שמואל סולה - מהנדס ואופה לחמי מחמצת",

      // New About Detail page content
      aboutPageTitle: "אודות",
      aboutPageText1:
        'ברוכים הבאים לעולם של "סולה לחמים" המקום שבו הפשטות משתלבת עם תוצאות מעולות, והאפייה הופכת להנאה אמיתית, נגישה לכל אחד ואחת.',
      aboutPageText2:
        "שמי שמואל (סרגיי) סולה. במקצועי אני מהנדס מכונות ופיתוח, אך כבר למעלה מ-20 שנה התשוקה האמיתית שלי היא לחם. לא סתם לחם, אלא לחם חי, ריחני ואמיתי, אך ורק על בסיס מחמצת. אני אופה הכול: מלחם יומיומי פשוט ועד לחמניות, בגטים, חלות מתוקות, ממולאים עם ירקות, בשר או דגים בתוך בצק מחמצת ועוד שלל מאפים טעימים. שמרים כבר מזמן לא נמצאים אצלי בבית וכל האפייה שלי מתבססת על מחמצת בלבד.",
      aboutPageText3:
        "אני מאמין שלחם איכותי וטעים צריך להיות נגיש לכל אדם, לא משנה מה הרקע שלו או הניסיון שלו באפייה. השיטה שלי מבוססת על פשטות, סבלנות ואהבה לתהליך.",
      aboutPageText4:
        "בסדנאות שלי לא תמצאו טכניקות מסובכות או ציוד יוקרתי. אני מלמד איך להכין לחם מדהים עם מה שיש בבית - קמח רגיל, מים, מלח ומחמצת טבעית.",
      aboutPageText5:
        "הנישה שלי מבוססת על כנות, פתיחות וליווי ללא הגבלת זמן. אני מאמין שאנחנו משתפים ידע בפתיחות מלאה, כולם מרוויחים. אחרי כל סדנה, אני נשאר זמין לכל שאלה או בעיה.",
      aboutPageText6:
        '"סולה לחמים" הוא לא רק אתר, זהו קהילה של אנשים שאוהבים אפייה אמיתית. יחד אנחנו לומדים, מתנסים ומשתפים את האהבה שלנו ללחם טרי ומחמצת טבעית.',

      // Testimonials section
      testimonials: "לקוחות ממליצים",
      testimonialsSubtitle: "המילים שלכם - ההשראה שלי.",
      testimonialsDescription:
        "כאן תוכלו לקרוא חוויות אמיתיות של משתתפי הסדנאות,\nשלמדו לאפות לחם מחמצת בבית ויצאו עם כיכר מושלמת וחיוך גדול.",
      testimonial1: {
        name: "מקסים ויוליה יאכנין",
        text: "פעם שנייה אצל סרגיי – הפעם בגטים ופוקצ'ות ושוב מושלם!\n אווירה נעימה, הסברים סבלניים,\nושיתוף מלא בידע ובאהבה לאפייה.\n בזכות לוסי גם זכינו לארוחת בוקר ביתית ומפנקת לצד לחמים מושלמים על מחמצת.",
      },
      testimonial2: {
        name: "שטיבל טחנות קמח",
        text: "את סרגיי אני מכיר כבר 8 שנים, עוד מתקופת היקב, כשכבר אז היה מראה לי את הלחמים שאפה בבית.\n בשבוע שעבר הוזמנתי לסדנת באגטים בביתו שבאור עקיבא – חוויה מלמדת, טעימה ומהנה, עם סרגיי המדריך בסבלנות ובידענות רבה.",
      },
      testimonial3: {
        name: "קרין גורן",
        text: "מי צריך את פריז? באגטים קריספיים ושחומים יוצאים גם מהתנור הביתי.\n סדנה כיפית וטעימה של כ־3 שעות עם סרגיי סולה, מלאה בטיפים וסודות – בלי ציוד מיוחד ועם תוצאות מעולות.\n כבונוס: גור מחמצת ותמיכה לכל החיים. מומלץ במיוחד אצל סרגיי בבית באור עקיבא.",
      },

      // Thank You page
      thankYou: "תודה שנרשמת!",
      registrationSuccess:
        "ההרשמה שלך התקבלה בהצלחה. נציג שלנו יצור איתך קשר בקרוב עם פרטים נוספים.",
      backToHome: "חזרה לדף הבית",

      // Payment Success
      paymentSuccess: "התשלום עבר בהצלחה!",
      paymentSuccessMessage:
        "נרשמת בהצלחה ✅ האישור ישלח בקרוב למייל שלך. אנחנו כבר מצפים לפגוש אותך בסדנה!",
      paymentDetails: "פרטי התשלום",
      transactionId: "מספר עסקה",
      amount: "סכום",
      status: "סטטוס",
      approved: "אושר",
      pending: "ממתין",
      registrationDetails: "פרטי ההרשמה",
      viewMoreWorkshops: "צפה בסדנאות נוספות",
      paymentStatus: "אושר",

      // Payment Failed
      paymentFailed: "התשלום נכשל",
      paymentFailedMessage:
        "❌ נראה שהייתה תקלה בתהליך,\n אנא נסה שוב או צור קשר.",
      retryPayment: "נסה שוב",
      contactSupport: "פנה לתמיכה",
      needHelp: "צריך עזרה?",
      helpMessage:
        "אם הבעיה נמשכת, אנא פנה אלינו ונשמח לעזור לך להשלים את ההרשמה.",
      errorCode: "קוד שגיאה",
      paymentErrorMessage: "הודעת שגיאה",
      failed: "נכשל",
      errorDetails: "פרטי שגיאה",
      errorDetailsMessage: "שגיאה בתהליך התשלום",
      needHelpMessage:
        "אם הבעיה נמשכת, אנא פנה אלינו ונשמח לעזור לך להשלים את ההרשמה.",

      // Common
      readMore: "קראו עוד",
      back: "חזרה",
      allWorkshops: "לכל הסדנאות",
      backToWorkshops: "חזרה לכל הסדנאות",
      backToWorkshopsDetail: "חזרה לדף הסדנה",
      allRightsReserved: "כל הזכויות שמורות",
      comingSoon: "בקרוב...",

      // Blog page
      blogSubtitle: "ידע, השראה וריח של לחם טרי.",
      blogDescriptionPart1:
        "כאן תמצאו טיפים, מתכונים ומאמרים על אפייה עם מחמצת –",
      blogDescriptionPart2:
        "מהבסיס ועד שדרוגים יצירתיים, כך שתמיד יהיה לכם משהו להוציא מהתנור.",
      blogButton: "מעבר לבלוג",
      notPublished: "לא פורסם",
      backToBlog: "חזרה לבלוג מתכונים/מאמרים",
      postNotFound: "הפוסט לא נמצא",
      cannotLoadPost: "לא ניתן לטעון את הפוסט",
      blog_detail: "בלוג",
      readNow: "מעבר לבלוג",

      // Admin panel
      admin: {
        dashboard: "לוח בקרה",
        dashboardTitle: "שלום שמואל,",
        dashboardSubtitle: "להלן סטטוס האתר שלך",
        registrations: "הרשמות",
        contact: "הודעות",
        workshops: "סדנאות",
        blog: "בלוג",
        media: "מדיה",
        settings: "הגדרות",
        giftVoucher: "שובר מתנה",
        logout: "התנתק",
        totalRegistrations: "הרשמות סה״כ",
        upcomingWorkshops: "סדנאות באתר",
        blogPosts: "פוסטים בבלוג",
        mediaFiles: "קבצי מדיה",
        recentActivity: "פעילות אחרונה באתר",
        addWorkshop: "הוסף סדנה",
        editWorkshop: "ערוך סדנה",
        addPost: "הוסף פוסט בלוג",
        editPost: "ערוך פוסט",
        edit: "ערוך",
        delete: "מחק ",
        title: "כותרת",
        description: "תיאור",
        excerpt: "תקציר",
        content: "תוכן",
        date: "תאריך",
        price: "מחיר",
        image: "תמונה",
        location: "מיקום",
        author: "מחבר",
        cancel: "יציאה ללא שינויים",
        saveChanges: "שמירת הפוסט והעלאתו",
        confirmDelete: "האם אתה בטוח שברצונך למחוק?",
        loadingData: "טוען נתונים...",
        loading: "טוען...",
        noRecentActivity: "אין פעילות אחרונה",
        uploading: "מעלה...",
        clickToUploadImage: "לחץ להעלאת תמונה או הזן URL למעלה",
        clickToChangeImage: "לחץ לשינוי התמונה",
        removeImage: "הסר תמונה",
        noMediaFiles: "אין קבצי מדיה עדיין",
        startUploading: "התחל להעלות תמונות כדי לראות אותן כאן",
        clickToUpload: "לחץ להעלאת תמונות",
        dragAndDrop: "או גרור וזרוק קבצים לכאן",
        uploadSuccess: "הועלו בהצלחה",
        files: "קבצים",
        fileDeleted: "הקובץ נמחק בהצלחה",
        uploadError: "שגיאה בהעלאת הקבצים",
        deleteError: "שגיאה במחיקת הקובץ",
        loadError: "שגיאה בטעינת קבצי המדיה",
        orderUpdated: "הסדר עודכן בהצלחה",
        orderUpdateError: "שגיאה בעדכון הסדר",
        contactMessages: "הודעות מערכת",
        activity: {
          newWorkshop: "סדנה חדשה נוספה",
          newBlogPost: "פוסט חדש פורסם",
          newRegistration: "הרשמה חדשה התקבלה",
          mediaUpload: "תמונה חדשה הועלתה",
        },
        generalSettings: "הגדרות כלליות",
        siteName: "שם האתר",
        siteDescription: "תיאור האתר",
        contactSettings: "הגדרות יצירת קשר",
        email: "אימייל",
        phone: "טלפון",
        socialMedia: "רשתות חברתיות",
        saveSettings: "שמור הגדרות",
        uploadMedia: "העלה מדיה חדשה",
      },
      login: {
        title: "כניסה למערכת ניהול",
        username: "שם משתמש",
        email: "אימייל",
        password: "סיסמה",
        submit: "כניסה",
        invalidCredentials: "שם משתמש או סיסמה שגויים",
      },

      // Validation messages
      invalidEmail: "כתובת אימייל לא תקינה",
      invalidPhone: "מספר טלפון לא תקין",
    },
  },
  ru: {
    translation: {
      // SEO - titles and descriptions per page
      seo: {
        homeTitle:
          "Мастер-классы по выпечке хлеба на закваске | Шмуэль Сола - SullaBread",
        homeDescription:
          "Мастер-классы по выпечке хлеба на закваске с Шмуэлем (Сергеем) Сола. Научитесь печь настоящий хлеб дома. Более 20 лет опыта.",
        workshopsTitle:
          "Мастер-классы по выпечке | Хлеб на закваске с Шмуэлем Сола",
        workshopsDescription:
          "Присоединяйтесь к персональным мастер-классам. Научитесь шаг за шагом печь свежий и полезный хлеб на закваске дома.",
        workshopDetailTitle: "Детали мастер-класса | Шмуэль Сола - SullaBread",
        workshopDetailDescription:
          "Подробности и запись на мастер-класс по выпечке хлеба на закваске с Шмуэлем Сола.",
        aboutTitle:
          "Шмуэль (Сергей) Сола | Пекарь хлеба на закваске более 20 лет",
        aboutDescription:
          "Познакомьтесь с Шмуэлем Сола, пекарем хлеба на закваске более 20 лет. Инженер, ставший пекарем.",
        blogTitle: "Блог о хлебе на закваске | Рецепты и советы - SullaBread",
        blogDescription:
          "Рецепты, советы и статьи о выпечке домашнего хлеба на закваске от Шмуэля Сола.",
        blogDetailTitle: "Статья | Блог о хлебе на закваске - SullaBread",
        blogDetailDescription:
          "Статья из блога о хлебе на закваске Шмуэля Сола. Советы, рецепты и знания о домашней выпечке.",
        galleryTitle: "Галерея | Фото с мастер-классов Шмуэля Сола",
        galleryDescription:
          "Фотографии с мастер-классов по выпечке, свежий хлеб из печи и моменты с мастер-классов Шмуэля Сола.",
        contactTitle: "Контакты | Шмуэль Сола - SullaBread",
        contactDescription:
          "Хотите записаться на мастер-класс или задать вопрос? Свяжитесь с Шмуэлем Сола.",
        privacyTitle: "Политика конфиденциальности | SullaBread",
        privacyDescription:
          "Политика конфиденциальности сайта SullaBread - мастер-классы по выпечке хлеба на закваске.",
        accessibilityTitle: "Заявление о доступности | SullaBread",
        accessibilityDescription:
          "Заявление о доступности сайта SullaBread - мастер-классы по выпечке хлеба на закваске.",
        cancellationTitle: "Политика отмены | SullaBread",
        cancellationDescription:
          "Политика отмены и возврата средств за мастер-классы SullaBread.",
        giftVoucherTitle:
          "Подарочный сертификат | Мастер-классы по выпечке - SullaBread",
        giftVoucherDescription:
          "Купите подарочный сертификат на мастер-класс по выпечке хлеба на закваске с Шмуэлем Сола. Идеальный подарок.",
      },

      // Navigation
      home: "Главная",
      workshops: "Мастер-классы",
      about: "О нас",
      giftVoucher: "Сертификат",
      contact: "Контакты",
      blog: "Блог рецептов и статей",
      gallery: "Галерия",
      openMenu: "Открыть меню",
      closeMenu: "Закрыть меню",
      mainNavigation: "Главная навигация",
      galleryDescriptionBolt: "Моменты, когда прямо из печи и от всего сердца.",
      allGallery: "Перейти к галерии",
      galleryDescription:
        "Взгляд внутрь мира домашней выпечки- свежие и ароматные хлеба, \n наполненные вдохновением мастер классы и улыбки тех, кто уже побывал \n Именно так это выглядит, когда всё и всегда от всего сердца.",
      location: "Место будет определено",
      previous: "Предыдущий",
      next: "Следующий",
      page: "Страница",
      of: "из",
      images: "изображений",

      // Home page
      heroTitleLine1: "Настоящий ремесленный хлеб,",
      heroTitleLine2: "Живая закваска,",
      heroTitleLine3: "Прекрасный результат",
      heroSubtitle:
        "Привет, я Шмуэль (Сергей) Сола. Научитесь со мной печь настоящий хлеб на закваске дома",
      heroDescription:
        "Я- Сергей Сулла, выпекаю хлеб на закваске уже более 20ти лет. Приходите ко мне научиться как испечь дома настоящий хлеб исключительно на закваске, без никаких секретов, без дрожжей и без страха перед этим.",
      heroImageAlt:
        "Главное изображение - качественный домашний хлеб с мастер-классов по выпечке",
      featuredWorkshops: "Рекомендуемые мастер-классы",
      viewWorkshops: "Смотреть мастер-классы",
      joinWorkshops: "Приходите сейчас на мастер классы",
      workshopsTitle: "Мастер классы по выпечке",
      workshopsDescriptionBolt:
        "Приходите и вы сами убедитесь, насколько просто испечь дома самому заквасочный хлеб. ",
      workshopsDescription:
        "На моих частных мастер классах вы научитесь шаг за шагом как испечь свежий, здоровый и необыкновенно вкусный ремесленный хлеб- без дрожжей, без “престижной” и дорогой муки и без страха перед этим.\n Мой метод подойдет абсолютно ко всем, даже к тем, кто ни разу до этого не занимался выпечкой.",
      purchaseNow: "Купить сейчас",
      loadingWorkshops: "Загрузка рекомендуемых мастер-классов...",
      noWorkshopsAvailable: "Нет доступных мастер-классов в данный момент",

      // Workshop page

      available: "Доступно",
      unavailable: "Недоступно",
      chooseDate: "Выбор даты семинара",
      selectDate: "Выбрать дату",
      viewDetails: "Посмотреть детали",
      viewImage: "Посмотреть изображение",
      upcomingWorkshops: "Предстоящие мастер-классы",
      workshopDetails: "Детали мастер-класса",
      price: "Цена",
      date: "Дата",
      time: "Время",
      duration: "Продолжительность",
      register: "Записаться",
      availableSeats: "Вакансии",
      full: "полный",
      workshopFull: "Мастер-класс заполнен",
      noDatesAvailable: "Даты проведения этого семинара пока не известны.",
      registrationForm: "Запись на мастер класс и оплата",
      numberOfPeople: "Количество человек на мастер класс",
      decreaseTickets: "Уменьшить количество билетов",
      increaseTickets: "Увеличить количество билетов",
      totalToPay: "Всего к оплате",
      recaptcha: "Проверка безопасности",
      paymentTransition: "Переход к оплате",
      paymentButton: "Оплатить",
      cancel: "Отмена",
      pleaseFillOutTheFollowingDetails:
        "Пожалуйста, заполните следующие детали",
      paymentForWorkshopRegistration: "Оплата за регистрацию на мастер-класс",
      pleaseCompletePaymentDetails: "Пожалуйста, завершите детали оплаты",
      securePaymentTranzila:
        "🔒 Оплата осуществляется через защищенную систему Tranzila. Данные вашей карты защищены и зашифрованы.",
      processingPayment: "Обрабатывается платеж...",
      pleaseWaitRedirecting:
        "Пожалуйста, подождите, перенаправляем вас к оплате",

      // Gift voucher (Подарочный сертификат)
      giftVoucherPageTitle: "Подарочный сертификат",
      giftVoucherPageSubtitle: "Прекрасный подарок для близких вам людей",
      giftVoucherPageIntro:
        "Выберите количество участников, оплатите сертификат, и персональный код будет отправлен на вашу эл. почту. Получатель сможет использовать код при записи на любой мастер-класс.",
      giftVoucherPeopleLabel: "Количество участников в сертификате",
      giftVoucherPricePerPerson: "Цена за человека",
      giftVoucherTotal: "Всего к оплате",
      giftVoucherPurchaseButton: "Купить подарочный сертификат",
      giftVoucherNotAvailable:
        "Покупка подарочных сертификатов сейчас недоступна. Пожалуйста, попробуйте позже.",
      giftVoucherSuccessTitle: "Сертификат успешно приобретен!",
      giftVoucherSuccessMessage:
        "Спасибо за покупку! Мы также отправили код сертификата на вашу эл. почту.",
      giftVoucherYourCode: "Ваш код сертификата",
      giftVoucherCodeNote:
        "Сохраните код - его нужно ввести при записи на мастер-класс.",
      giftVoucherActivationError:
        "Не удалось активировать сертификат. Обновите страницу или свяжитесь с нами.",
      giftVoucherCreating: "Создание сертификата...",

      // Gift voucher redemption in registration
      voucherCodeLabel: "У вас есть подарочный сертификат?",
      voucherCodePlaceholder: "Введите код сертификата",
      voucherApply: "Применить",
      voucherRemove: "Удалить сертификат",
      voucherApplied: "Сертификат применен! Покрывает {{count}} участников",
      voucherDiscount: "Скидка по сертификату",
      voucherChecking: "Проверка...",
      voucherNotFound: "Код сертификата не найден",
      voucherNotActive: "Сертификат еще не активен",
      voucherAlreadyRedeemed: "Сертификат уже использован",
      voucherInvalid: "Недействительный код сертификата",

      paymentSuccess: "Оплата принята",
      paymentSuccessMessage:
        "Спасибо за запись на мастер класс. Вы получите подтверждение на свою эл. почту.\n С радостью увидимся на мастер классе!",

      paymentDetails: "Детали оплаты",
      transactionId: "Номер оплаты",
      amount: "Сумма",
      status: "статус",
      approved: "Счастье",

      paymentFailed: "Платеж не прошел",
      paymentFailedMessage:
        "❌ Очевидно, были неточности в процессе. Пожалуйста, попробуйте еще раз или обратитесь ко мне напрямую.",
      failed: "неуспешный",
      errorDetails: "Детали ошибки",
      errorDetailsMessage: "Ошибка в процессе оплаты",
      needHelp: "Требуется помощь?",
      needHelpMessage:
        " Если проблема не разрешается, пожалуйста, обратитесь ко мне напрямую и я буду рад помочь вам во всем.",
      retryPayment: "Попробуйте снова",
      // Contact page
      contactUs: "Свяжитесь с нами",
      name: "Имя",
      email: "Email",
      message: "Сообщение",
      send: "Отправить",
      contactTitle: "Контакты",
      contactQuestions: "?У вас есть вопросы",
      contactIntro:
        ".Пожалуйста, свяжитесь со мной удобным вам методом и я свяжусь с вами быстро, насколько это возможно",
      namePlaceholder: "Полное имя",
      emailPlaceholder: "Адрес эл. почты (обязательно к заполнению)",
      phonePlaceholder: "Телефон",
      messagePlaceholder: "Оставьте здесь ваше сообщение…",
      sending: "Отправка...",
      sendButton: "Отправка данных",
      loading: "Загрузка...",
      processing: "Обрабатываю информацию...",
      errorMessage: "Ошибка отправки сообщения. Пожалуйста, попробуйте снова.",
      consentCheckbox:
        "Я согласен на обработку данных, которые отражены в этом бланке в соответствии с ",
      privacyPolicy: "политикой защиты личной информации",
      consentCheckboxDescription: "этого сайта.",
      thankYouTitle: "Спасибо, что связались со мной!",
      thankYouMessage:
        "Ваша просьба принята к рассмотрению. Я свяжусь с вами быстро, насколько это возможно.",

      // Email: contact auto-reply (контакты)
      emails: {
        contactAutoReply: {
          subject: "Спасибо, что связались с нами - {{siteName}}",
          title: "Ваше сообщение успешно получено!",
          greeting: "Здравствуйте",
          body: "Спасибо за обращение. Мы получили ваше сообщение и свяжемся с вами в ближайшее время.",
          yourMessage: "Содержание вашего сообщения:",
          regards: "С уважением,",
          teamLabel: "Команда",
          footer:
            "Это автоматический ответ, подтверждающий получение обращения.",
          defaultName: "Уважаемый клиент",
        },
        giftVoucher: {
          subject: "Ваш подарочный сертификат - {{siteName}}",
          title: "Ваш подарочный сертификат готов!",
          greeting: "Здравствуйте",
          body: "Спасибо за покупку подарочного сертификата. Ниже код для использования при записи на мастер-класс:",
          codeLabel: "Код сертификата",
          participantsLabel: "Сертификат на {{count}} участников",
          howToUse:
            "Введите код при записи на мастер-класс, чтобы получить скидку.",
          regards: "С уважением,",
          teamLabel: "Команда",
          footer:
            "Храните код в надежном месте. Сертификат можно использовать один раз.",
          defaultName: "Уважаемый клиент",
        },
      },

      // Privacy Policy page
      privacyPolicyTitle: "Политика защиты пользователей сайта",
      privacyWelcome: "Добро пожаловать на сайт Sullabread",
      privacyWelcomeText:
        "Мы берем на себя обязательство на защиту личных данных пользователей в соответствии с законом защиты личных и частных данных в Израиле и в соответствии со всеми последними уточнениями закона.",
      privacyCollectionTitle: "Обработка данных",
      privacyCollectionText:
        "Возможно, что в момент заполнения форм на сайте, Вам потребуется поставить галочку, что Вы согласны на обработку данных, которые указаны в форме. Эта галочка активная.",
      privacyRightsTitle: "Право на просмотр и удаление данных",
      privacyRightsText:
        "Для просмотра, уточнения или удаления информации, которую Вы нам предоставили, необходимо воспользоваться формой связи с нами в Контактах. Мы учтем Вашу просьбу в соответствии с законом.",
      privacyUsageTitle: "Использование информации",
      privacyUsageText:
        "Собранная информация используется для обработки обращений к нам, улучшения обслуживания и уточнений в соответствии с соглашением.",
      privacySecurityTitle: "Защита информации",
      privacySecurityText:
        "Мы используем все средства для защиты информации против неразрешенного доступа.",
      privacyCookiesTitle: "Использование Cookies",
      privacyCookiesTextUp:
        "Этот сайт использует файлы Cookie- для улучшения пользования сайтом и для сохранения ваших предпочтений. Cookies включают в себя:",
      privacyCookiesItem1: "Сохранение ваших языковых предпочтений",
      privacyCookiesItem2: "Сохранение предпочтений доступа на сайте",
      privacyCookiesItem3:
        "Сохранение времени вашего последнего посещения сайта",
      privacyCookiesItem4: "Улучшение пользовательских функций сайта",
      privacyCookiesTextDown:
        "Имеется возможность отключить использование Cookies в установках интернет эксплорер. Но это действие повлечет за собой воздействие на работу сайта.",
      privacyInquiriesTitle: "Обращения и просьбы",
      privacyInquiriesText:
        "По любому вопросу или просьбе, касающимися Вашей личной информации, пожалуйста, обратитесь к нам посредством заполнения формы в разделе Контакты.",
      backToPreviousPage: "Вернуться назад",
      // Accessibility Statement page
      accessibilityStatementTitle: "Заявление о доступности",
      accessibilityStatementIntro: "Заявление о доступности сайта Sullabread",
      accessibilityStatementIntroText:
        "Сайт Sullabread обязуется предоставлять доступные и равноправные услуги всем пользователям и обеспечивать удобное и эффективное использование сайта для всего населения, включая людей с ограниченными возможностями.",
      accessibilityStandardTitle: "Стандарт доступности",
      accessibilityStandardText:
        "Сайт соответствует требованиям израильского стандарта SI 5568 часть 1 (сентябрь 2023), основанного на рекомендациях WCAG 2.1 уровня AA организации W3C.",
      accessibilityFeaturesTitle: "Адаптации доступности, выполненные на сайте",
      accessibilityFeaturesList1:
        "Полная поддержка навигации с помощью клавиатуры",
      accessibilityFeaturesList2:
        "Поддержка программ чтения с экрана (Screen Readers)",
      accessibilityFeaturesList3:
        "Текстовые описания для изображений (Alt tags)",
      accessibilityFeaturesList4:
        "Адаптированный контраст цветов (минимальное соотношение контраста 4.5:1)",
      accessibilityFeaturesList5: "Поддержка иврита (RTL) и русского (LTR)",
      accessibilityFeaturesList6:
        "Возможность перехода к основному содержанию (Skip links)",
      accessibilityFeaturesList7:
        "Четкие стили focus для навигации с клавиатуры",
      accessibilityFeaturesList8: "Поддержка режима высокого контраста",
      accessibilityFeaturesList9: "Поддержка reduced motion",
      accessibilityFeaturesList10: "Правильная семантическая структура HTML",
      accessibilityFeaturesList11: "ARIA метки для интерактивных элементов",
      accessibilityFeaturesList12: "Доступные сообщения об ошибках",
      accessibilityContactTitle: "Координатор доступности",
      accessibilityContactText:
        "Если вы столкнулись с проблемой доступности на сайте или у вас есть предложения по улучшению доступности, пожалуйста, свяжитесь с нами:",
      accessibilityContactName: "Имя координатора доступности: Шмуэль Сулла",
      accessibilityContactEmail: "Email: [Введите адрес электронной почты]",
      accessibilityContactPhone: "Телефон: [Введите номер телефона]",
      accessibilityContactNote:
        'Пожалуйста, укажите в теме сообщения: "Обращение по вопросу доступности"',
      accessibilityImprovementsTitle: "Запланированные улучшения",
      accessibilityImprovementsText:
        "Мы продолжаем улучшать доступность сайта на постоянной основе. Если у вас есть предложения по улучшению, мы будем рады услышать от вас.",
      accessibilityLastUpdate: "Последнее обновление: январь 2025",

      // Cancellation Policy page
      cancellationPolicyTitle: "Политика отмены и возврата денег",
      cancellationPolicyIntro: "Политика отмены и возврата денег",
      cancellationPolicyIntroText:
        "Вследствие того, что я сохраняю для вас место и посвящаю заранее много своего времени на подготовку различных видов теста и исходных материалов, прошу понять меня в отношении политики возврата денег и отмены своего участия.",
      cancellationPolicyRegistrationTitle: "Регистрация на мастер класс",
      cancellationPolicyRegistrationText:
        "Регистрация на мастер класс осуществляется заранее и является обязательством по сохранению места.",
      cancellationPolicy72HoursTitle:
        "Отмена участия до трех дней (72 часа) до начала мастер класса",
      cancellationPolicy72HoursText:
        "Платеж будет возвращен полностью, за исключением налога 5%, который берет с меня кредитная компания. Есть возможность перенести свое участие на другие даты в соответствии с наличием свободных мест.",
      cancellationPolicy24to72HoursTitle: "Отмена участия от 24 до 72 часов",
      cancellationPolicy24to72HoursText:
        "Будет возвращена 50% стоимости класса. В этом случае есть возможность передать свое участие другому лицу и сообщить об этом мне заранее.",
      cancellationPolicyLessThan24HoursTitle:
        "Отмена участия менее, чем 24 часа до мастер класса или неприбытие на класс по любой причине",
      cancellationPolicyLessThan24HoursText:
        "В этом случае не будет произведен возврат денег. В этом случае есть возможность передать свое участие другому лицу и сообщить об этом мне заранее.",

      // Accessibility Toolbar
      accessibilityTools: "Инструменты доступности",
      increaseText: "Увеличить текст",
      decreaseText: "Уменьшить текст",
      grayscale: "Оттенки серого",
      highContrast: "Высокий контраст",
      invertedContrast: "Инвертированный контраст",
      lightBackground: "Светлый фон",
      highlightLinks: "Выделить ссылки",
      readableFont: "Читаемый шрифт",
      reset: "Сброс",
      close: "Закрыть",

      // About page
      aboutTitle: "Наша история",
      aboutSubtitle: "Маленькая пекарня с большой любовью к хлебу",
      ourValues: "Наши ценности",
      ourStory: "Наша история",
      storyText1:
        "Все началось с любви к свежему хлебу и натуральной закваске. После многих лет экспериментов мы решили поделиться нашими знаниями и опытом с другими.",
      storyText2:
        "Сегодня мы проводим мастер-классы и обучаем людей со всей страны традиционному искусству выпечки.",
      aboutMainTitle: "О нас",
      aboutDescriptionBold:
        "Я Сергей Сулла, инженер и пекарь на закваске уже более 20-ти лет.",
      aboutDescriptionRegular:
        "На моих мастер классах я обучаю как испечь самому настоящий, свежий, живой и ароматный хлеб без промышленных дрожжей, без “престижной” и дорогой муки и предоставляя все свои профессиональные секреты. Простой и доступный метод, личная поддержка каждого и теплая атмосфера сообщества любителей хлеба.",
      aboutDescription:
        "Я Шмуэль (Сергей) Сола, инженер и пекарь хлеба уже более 20 лет. На моих персональных мастер-классах я обучаю, как готовить дома настоящий хлеб, без секретов, без дрожжей и без страха. Простой метод, личный совет и теплая сообщество любителей хлеба.",
      aboutButton: "Еще обо мне",
      aboutImageAlt: "Шмуэль Сола - инженер и пекарь хлеба",

      // New About Detail page content
      aboutPageTitle: "Обо мне",
      aboutPageText1:
        "Добро пожаловать в мир “Хлеба Суллы”- место, где простота сочетается с прекрасными результатами и вся выпечка превращается в настоящее удовольствие, доступное абсолютно каждому.",
      aboutPageText2:
        "Меня зовут Сергей Сулла. По профессии я инженер- механик, разработчик, но вот уже более 20-ти лет мое истинное и настоящее призвание- это хлеб на закваске. И не просто хлеб, а настоящий, “живой”, с необыкновенными вкусом и ароматом хлеб на закваске.  На закваске я выпекаю абсолютно всё: от простого ежедневного хлеба и до булочек, багетов, различных видов сладких хал, мясных, рыбных и овощных блюд в заквасочном тесте, а также множество других разнообразных необыкновенно вкусных выпечек. Промышленные дрожжи- их уже давно нет у меня в доме и вся моя выпечка осуществляется только на основе закваски.",

      aboutPageText3:
        "Я твердо убежден в том, что вкусный, здоровый и качественный хлеб должен быть доступен абсолютно каждому. Поэтому я разработал метод выпечки, который, с одной стороны, очень прост сам по себе и, с другой стороны, позволяет достичь очень хороших результатов. Этот мой метод выпечки на закваске также прекрасно подойдет и тем, кто никогда сам не выпекал дома подобные изделия.",
      aboutPageText4:
        "На моих мастер классах вы никогда не увидите каких-то сложных методик, редких продуктов или дорогих и “престижных” видов импортной муки. Только обычное и настоящее тесто, методика шаг за шагом и самая простая и обычная мука из ближайшего к вашему дому супермаркета. Даже из самой простой и доступной муки можно испечь дома необыкновенный, очень вкусный, ароматный и полезный хлеб- и я вас научу, как это делается.",
      aboutPageText5:
        "Мой метод основан на открытости во всем, а также поддержке без ограничения во времени. У меня нет никаких профессиональных секретов и я щедро делюсь всеми своими знаниями и всем своим опытом, которые я накопил в течение десятков лет работы с с заквасочным тестом. Если вы были на моем мастер классе, то даже по прошествии многих лет вы всегда сможете обратиться ко мне с любым вопросом. И я отвечу каждому, как будто мы только вчера вместе замешивали тесто.",
      aboutPageText6:
        "“Хлеба Суллы”- это не только интернетный сайт. Это сообщество людей, которые увлечены настоящей, живой и здоровой выпечкой. И, если вы ищете знания и умение как испечь дома хлеб на закваске без промышленных дрожжей,- вы находитесь в правильном месте.",

      // Testimonials section
      testimonials: "Отзывы участников классов",
      testimonialsSubtitle: "Ваши отклики- это мое вдохновение.",
      testimonialsDescription:
        " Здесь вы сможете прочесть настоящие отзывы участников моих классов, которые уже научились выпекать. \n дома заквасочные хлеба и получать, кроме хлеба, истинное удовольствие от этого.",
      testimonial1: {
        name: "Максим и Юля Яхнин",
        text: "Уже второй раз мы на классе у Сергея- на этот раз класс по багетам и фокаччам- и опять выше всяких похвал! Приятная атмосфера, терпеливые объяснения всего и полная подача знаний, включая любовь к выпечке. Благодаря Люсе также получили удовольствие от вкусного домашнего завтрака, включая свежеиспеченные заквасочные хлеба.",
      },
      testimonial2: {
        name: "Мукомольня Штибель",
        text: "Уже 8 лет я знаком с Сергеем, с тех пор, как я работал в пекарне на винодельне Тишби, когда Сергей показывал мне испеченные дома хлеба. На прошлой неделе я был приглашен на мастер класс по багетам у него дома, в Ор Акиве. Это было удовольствие от учебы и от всех вкусных вещей, которые были там. Сергей большим терпением передает все свои большие знания и умения.",
      },
      testimonial3: {
        name: "Карин Горен",
        text: "Зачем ехать в Париж? Хрустящие и зажаренные багеты можно испечь и в обычной домашней духовке. Отличный и 'вкусный' мастер класс с Сергеем Сулла, со всеми деталями и без секретов и без специального оборудования и с прекрасным результатом. В качестве бонуса- поддержка на всю жизнь. Очень советую мастер класс Сергея в Ор Акиве.",
      },

      // Thank You page
      thankYou: "Спасибо за регистрацию!",
      registrationSuccess:
        "Ваша регистрация успешно получена. Наш представитель свяжется с вами в ближайшее время с дополнительной информацией.",
      backToHome: "Вернуться на главную",

      // Common
      readMore: "Подробнее",
      back: "Назад",
      backToWorkshops: "Вернуться ко всем мастер классам",
      allRightsReserved: "Все права защищены",
      backToWorkshopsDetail: "Вернуться к деталям мастер класса",
      comingSoon: "Скоро...",
      allWorkshops: "Все мастер классы",

      // Blog page
      blogSubtitle: "Знания, вдохновение и запах свежеиспеченного хлеба.",
      blogDescriptionPart1:
        "Здесь вы найдете информацию, рецепты и статьи о выпечке на закваске-",
      blogDescriptionPart2:
        "от самых основ и до совершенствования в этом, чтобы вы смогли достать из печи самое лучшее.",
      blogButton: "Перейти в блог",
      notPublished: "Не опубликовано",
      backToBlog: "Вернуться в блог",
      postNotFound: "Пост не найден",
      cannotLoadPost: "Не удалось загрузить пост",
      blog_detail: "Блог",
      readNow: "Перейти к блогу",

      // Admin panel
      admin: {
        dashboard: "Панель управления",
        registrations: "Регистрации",
        contact: "Сообщения",
        workshops: "Мастер-классы",
        blog: "Блог",
        media: "Медиа",
        settings: "Настройки",
        giftVoucher: "Подарочный сертификат",
        logout: "Выйти",
        totalRegistrations: "Всего регистраций",
        upcomingWorkshops: "Предстоящие мастер-классы",
        blogPosts: "Записи в блоге",
        mediaFiles: "Медиафайлы",
        recentActivity: "Последняя активность",
        addWorkshop: "Добавить мастер-класс",
        edit: "Редактировать",
        delete: "Удалить",
        activity: {
          newWorkshop: "Добавлен новый мастер-класс",
          newBlogPost: "Опубликована новая запись",
          newRegistration: "Получена новая регистрация",
          mediaUpload: "Загружен новый файл",
        },
        generalSettings: "Общие настройки",
        siteName: "Название сайта",
        siteDescription: "Описание сайта",
        contactSettings: "Настройки контактов",
        email: "Email",
        phone: "Телефон",
        socialMedia: "Социальные сети",
        saveSettings: "Сохранить настройки",
        uploadMedia: "Загрузить медиа",
        orderUpdated: "Порядок успешно обновлен",
        orderUpdateError: "Ошибка обновления порядка",
      },
      login: {
        title: "Вход в систему управления",
        username: "Имя пользователя",
        password: "Пароль",
        submit: "Войти",
        invalidCredentials: "Неверное имя пользователя или пароль",
      },

      // Validation messages
      invalidEmail: "Неверный адрес электронной почты",
      invalidPhone: "Неверный номер телефона",

      // Cookie Consent
      cookieBannerTitle: "Мы используем файлы cookie",
      cookieBannerDescription:
        "Мы используем файлы cookie для улучшения вашего опыта на сайте, запоминания ваших предпочтений и предоставления персонализированного контента. Выберите типы файлов cookie, которые вы хотите разрешить.",
      acceptAll: "Принять все",
      rejectAll: "Отклонить все",
      customize: "Настроить",
      cookiePolicy: "Политика cookie",
      cookieCustomizeTitle: "Настройка предпочтений cookie",
      cookieCustomizeDescription:
        "Выберите типы файлов cookie, которые вы хотите разрешить. Основные файлы cookie необходимы для работы сайта и не могут быть отключены.",
      cookieEssentialTitle: "Основные файлы cookie",
      cookieEssentialDescription:
        "Эти файлы cookie необходимы для базовой работы сайта и не могут быть отключены. Они включают токены аутентификации, идентификаторы сессий и токены безопасности.",
      cookieFunctionalTitle: "Функциональные файлы cookie",
      cookieFunctionalDescription:
        "Эти файлы cookie улучшают функциональность сайта и сохраняют ваши предпочтения, такие как язык, тема и доступность.",
      cookieAnalyticsTitle: "Аналитические файлы cookie",
      cookieAnalyticsDescription:
        "Эти файлы cookie помогают нам понять, как вы используете сайт, и улучшить наши производительность и контент.",
      cookieMarketingTitle: "Маркетинговые файлы cookie",
      cookieMarketingDescription:
        "Эти файлы cookie используются для целевой рекламы и отслеживания эффективности наших маркетинговых кампаний.",
      alwaysActive: "Всегда активен",
      enabled: "Включен",
      disabled: "Отключен",
      saving: "Сохранение...",
      savePreferences: "Сохранить настройки",
    },
  },
  en: {
    translation: {
      // Navigation
      home: "Home",
      workshops: "Workshops",
      about: "About",
      contact: "Contact",
      blog: "Blog",
      gallery: "Gallery",
      galleryDescriptionBolt: "Moments from the oven and heart",
      galleryDescription:
        "A glimpse into the world of home baking – fresh bread, inspiring workshops, and smiles from course graduates.\nThis is what baking from the heart looks like",
      location: "Location to be determined",

      // Home page
      heroTitleLine1: "Real bread,",
      heroTitleLine2: "simple sourdough,",
      heroTitleLine3: "perfect result",
      heroSubtitle:
        "Hello, I'm Shmuel (Sergei) Sulla. Learn with me to bake real sourdough bread at home",
      heroDescription:
        "Shmuel (Sergei) Sulla, bread baker for 20 years. Let's learn how to make real bread at home based only on sourdough, without secrets, without yeast, and without fear.",
      featuredWorkshops: "Featured Workshops",
      viewWorkshops: "View Workshops",
      joinWorkshops: "Join Workshops Now",
      workshopsDescriptionBolt:
        "Let's discover how simple it is to make real sourdough bread at home.",
      workshopsDescription:
        "In my personal workshops, you'll learn step-by-step how to bake fresh, healthy, and delicious bread – without yeast, without expensive flour, and without stress.\nMy method suits everyone, even if this is your first time in the kitchen.",
      purchaseNow: "Purchase Now",
      loadingWorkshops: "Loading featured workshops...",
      noWorkshopsAvailable: "No workshops available at the moment",

      // Workshop page
      upcomingWorkshops: "Upcoming Workshops",
      workshopDetails: "Workshop Details",
      price: "Price",
      duration: "Duration",
      register: "Register",
      workshopFull: "Workshop Full",
      date: "Date",
      time: "Time",

      // Contact page
      contactUs: "Contact Us",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send",
      contactTitle: "Contact Us",
      contactQuestions: "Do you have questions?",
      contactIntro:
        "Feel free to contact us in any way that's convenient for you, and I'll get back to you as soon as possible.",
      namePlaceholder: "Full name",
      emailPlaceholder: "Email (required)",
      messagePlaceholder: "Leave your message here",
      sending: "Sending...",
      sendButton: "Send",
      loading: "Loading...",
      errorMessage: "Error sending message. Please try again.",

      // Email: contact auto-reply (fallback LTR)
      emails: {
        contactAutoReply: {
          subject: "Thank you for contacting us - {{siteName}}",
          title: "Your message was received successfully!",
          greeting: "Hello",
          body: "Thank you for reaching out. We have received your message and will get back to you as soon as possible.",
          yourMessage: "Content of your message:",
          regards: "Best regards,",
          teamLabel: "Team",
          footer:
            "This is an automatic reply confirming receipt of your message.",
          defaultName: "Dear customer",
        },
      },

      // About page
      aboutTitle: "Our Story",
      aboutSubtitle: "A small bakery with a big love for bread",
      ourValues: "Our Values",
      ourStory: "Our Story",
      storyText1:
        "It all started with a love for fresh bread and natural sourdough. After years of trial and error, we decided to share our knowledge and experience with others.",
      storyText2:
        "Today we host workshops and teach people from all over the country the art of traditional baking.",
      aboutMainTitle: "About",
      aboutDescriptionBold:
        "I'm Shmuel (Sergei) Sulla, an engineer and sourdough bread baker for over 20 years.",
      aboutDescriptionRegular:
        "In my workshops, I teach how to make real, fresh, and fragrant bread at home – without yeast, without expensive flour, and without professional secrets. Simple method, personal guidance, and a warm community of bread lovers.",
      aboutButton: "Learn More About Me",
      aboutImageAlt: "Shmuel Sulla - Engineer and Sourdough Bread Baker",

      // New About Detail page content
      aboutPageTitle: "About",
      aboutPageText1:
        'Welcome to the world of "Sulla Breads" - a place where real baking meets simplicity and love for fresh bread and natural sourdough.',
      aboutPageText2:
        "My name is Shmuel (Sergei) Sulla. By profession, I'm a mechanical engineer and developer, but in my heart, I'm a bread baker for over 20 years. My passion for baking started when I was a child, watching my grandmother make bread with natural sourdough.",
      aboutPageText3:
        "I believe that quality and delicious bread should be accessible to every person, regardless of their background or experience in baking. My method is based on simplicity, patience, and love for the process.",
      aboutPageText4:
        "In my workshops, you won't find complicated techniques or expensive equipment. I teach how to make amazing bread with what you have at home - regular flour, water, salt, and natural sourdough.",
      aboutPageText5:
        "My niche is based on honesty, openness, and unlimited time guidance. I believe that when we share knowledge with complete openness, everyone wins. After every workshop, I remain available for any question or problem.",
      aboutPageText6:
        '"Sulla Breads" is not just a website, it\'s a community of people who love real baking. Together we learn, experiment, and share our love for fresh bread and natural sourdough.',

      // Testimonials section
      testimonials: "Customer Testimonials",
      testimonialsSubtitle: "Your words - my inspiration.",
      testimonialsDescription:
        "Here you can read real experiences from workshop participants who learned to bake sourdough bread at home and came out with a perfect loaf and a big smile.",
      testimonial1: {
        name: "Maxim and Yulia Yakhnin",
        text: "Second time with Sergei – this time baguettes and focaccia and again perfect!\n Pleasant atmosphere, patient explanations,\nand full sharing of knowledge and love for baking.\n Thanks to Lucy, we also enjoyed a homemade and pampering breakfast alongside perfect sourdough bread.",
      },
      testimonial2: {
        name: "Shtibel Flour Mills",
        text: "I've known Sergei for 8 years now, since the winery days, when he was already showing me the breads he baked at home.\n Last week I was invited to a baguette workshop at his home in Or Akiva – an educational, tasty and enjoyable experience, with Sergei guiding with patience and great knowledge.",
      },
      testimonial3: {
        name: "Tal Liani",
        text: "For three years I tried to bake alone, with successes and failures, but in the workshop I finally understood where I was wrong at every step.\n A fascinating experience, full of knowledge, practice and enjoyment – I came out ready to reopen the home bakery.",
      },

      // Payment Success
      paymentSuccess: "Payment Completed Successfully!",
      paymentSuccessMessage:
        "Thank you for registering for the workshop. You will receive a confirmation email soon.",
      paymentDetails: "Payment Details",
      transactionId: "Transaction ID",
      amount: "Amount",
      status: "Status",
      approved: "Approved",
      pending: "Pending",
      registrationDetails: "Registration Details",
      viewMoreWorkshops: "View More Workshops",

      // Payment Failed
      paymentFailed: "Payment Failed",
      paymentFailedMessage:
        "An error occurred during the payment process. Please try again or contact support.",
      retryPayment: "Try Again",
      contactSupport: "Contact Support",
      needHelp: "Need Help?",
      helpMessage:
        "If the problem persists, please contact us and we'll be happy to help you complete your registration.",
      errorCode: "Error Code",
      paymentErrorMessage: "Error Message",
      Failed: "Failed",

      // Common
      readMore: "Read More",
      back: "Back",
      backToWorkshops: "Back to All Workshops",
      allRightsReserved: "All rights reserved",
      comingSoon: "Coming Soon...",

      // Blog page
      blogSubtitle: "Knowledge, inspiration, and the aroma of bread",
      blogDescriptionPart1:
        "Here you'll find tips, recipes, and articles about sourdough baking –",
      blogDescriptionPart2:
        "from basics to modern recipes, so you always have something to take out of the oven.",
      blogButton: "Go to Blog",
      notPublished: "Not Published",
      backToBlog: "Back to Blog",
      postNotFound: "Post not found",
      cannotLoadPost: "Cannot load post",

      // Admin panel
      admin: {
        dashboard: "Dashboard",
        registrations: "Registrations",
        contact: "Messages",
        workshops: "Workshops",
        blog: "Blog",
        media: "Media",
        settings: "Settings",
        logout: "Logout",
        totalRegistrations: "Total Registrations",
        upcomingWorkshops: "Upcoming Workshops",
        blogPosts: "Blog Posts",
        mediaFiles: "Media Files",
        recentActivity: "Recent Activity",
        addWorkshop: "Add Workshop",
        editWorkshop: "Edit Workshop",
        addPost: "Add Post",
        editPost: "Edit Post",
        edit: "Edit",
        delete: "Delete",
        title: "Title",
        description: "Description",
        excerpt: "Excerpt",
        content: "Content",
        date: "Date",
        price: "Price",
        image: "Image",
        location: "Location",
        author: "Author",
        cancel: "Cancel",
        saveChanges: "Save Changes",
        confirmDelete: "Are you sure you want to delete?",
        loadingData: "Loading data...",
        loading: "Loading...",
        noRecentActivity: "No recent activity",
        uploading: "Uploading...",
        clickToUploadImage: "Click to upload image or enter URL above",
        clickToChangeImage: "Click to change image",
        removeImage: "Remove image",
        noMediaFiles: "No media files yet",
        startUploading: "Start uploading images to see them here",
        clickToUpload: "Click to upload images",
        dragAndDrop: "Or drag and drop files here",
        uploadSuccess: "Successfully uploaded",
        files: "files",
        fileDeleted: "File deleted successfully",
        uploadError: "Error uploading files",
        deleteError: "Error deleting file",
        loadError: "Error loading media files",
        orderUpdated: "Order updated successfully",
        orderUpdateError: "Error updating order",
        activity: {
          newWorkshop: "New workshop added",
          newBlogPost: "New blog post published",
          newRegistration: "New registration received",
          mediaUpload: "New image uploaded",
        },
        generalSettings: "General Settings",
        siteName: "Site Name",
        siteDescription: "Site Description",
        contactSettings: "Contact Settings",
        email: "Email",
        phone: "Phone",
        socialMedia: "Social Media",
        saveSettings: "Save Settings",
        uploadMedia: "Upload Media",
      },
      login: {
        title: "Admin Panel Login",
        username: "Username",
        password: "Password",
        submit: "Login",
        invalidCredentials: "Invalid username or password",
      },

      // Validation messages
      invalidEmail: "Invalid email address",
      invalidPhone: "Invalid phone number",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("i18nextLng") || "he", // שפת ברירת מחדל
  fallbackLng: "he",
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
});

export default i18n;
